<template lang="pug">
.ow-data-container(@click="expand = !expand")
  .ow-data
    .ow-number
      span.material-symbols-outlined(:class="`color-${data.brand}`") shopping_bag
      span.tag(:class="`bg-${data.brand}`") {{ data.order }}

    .ow-status
      .tag(:style="styleStatus") {{ translateStatus(data.status) }}

    .ow-method(v-if="!history && data.methodPay")
      img(:src="`${imagePath}/methods/light/mini-${data.methodPay}.png`" :alt="data.methodPay")

    .ow-total(v-if="!history") {{ money(data.total) }}

    .ow-collected(v-if="!history && data.collectedValue") {{ money(data.collectedValue) }}

    .ow-name.capitalize(v-if="!history") {{ name(data.name) }}

    .ow-location.capitalize(v-if="!history") {{ data.location }}

    .ow-phone(v-if="!history && data.phones && data.phones.length") {{ data.phones[0] }}

    .ow-date(v-if="!history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

    .ow-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    .ow-date(v-if="history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

  .ow-actions-container(@click.stop="")
    .ow-actions
      router-link.ow-print(:to="`/print-remission?index=${realIndex}`" @click.native.stop="")
        span.material-symbols-outlined print

      .buttons-actions(v-if="data.status === 'created'")
        shActionButton(:action="declineOrder" :params="[data.order]" text="Declinar" textRunning="Declinando")
        shActionButton(:action="approveOrder" :params="[data.order]" text="Aprobar" textRunning="Aprobando")

      .buttons-actions(v-if="data.status === 'approved'")
        shActionButton(:action="disapproveOrder" :params="[data.order]" text="Desaprobar" textRunning="Desaprobando")
        shActionButton(:action="collectOrder" :params="[data.order]" text="Pagar" textRunning="Pagando")

      .buttons-actions(v-if="data.status === 'paid'")
        shActionButton(:action="returnCollectOrder" :params="[data.order]" text="Eliminar Pago" textRunning="Eliminando")

  transition(name="slide-fade")
    shForm.list-ow(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-ow(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import gqlOrder from '@/graphql/order'
import gql from '@my/graphql'

export default {
  name: 'OrderWholesaler',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory },

  props: {
    data: Object,
    index: Number,
    realIndex: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    name (value) {
      if (!value) return value
      const names = value.split(' ')
      return names[0] || names[1]
    },

    async declineOrder (order) {
      const mutation = gqlOrder.DECLINE
      if (!order) return
      const response = await gql.mutate(mutation, { order })
      if (response) modals.showMessage({ message: `Se declinó la orden ${order} correctamente` })
    },

    async approveOrder (order) {
      const mutation = gqlOrder.APPROVE
      if (!order) return
      const response = await gql.mutate(mutation, { order })
      if (response) modals.showMessage({ message: `Se aprobó la orden ${order} correctamente` })
    },

    async disapproveOrder (order) {
      const mutation = gqlOrder.DISAPPROVE
      if (!order) return
      const response = await gql.mutate(mutation, { order })
      if (response) modals.showMessage({ message: `Se desaprobó la orden ${order} correctamente` })
    },

    async collectOrder (order) {
      const mutation = gqlOrder.COLLECT
      if (!order) return
      const response = await gql.mutate(mutation, { order })
      if (response) modals.showMessage({ message: `Se cobró la orden ${order} correctamente` })
    },

    async returnCollectOrder (order) {
      const mutation = gqlOrder.RETURN_COLLECT
      if (!order) return
      const response = await gql.mutate(mutation, { order })
      if (response) modals.showMessage({ message: `Se devolvió el cobro de la orden ${order} correctamente` })
    },

    translateStatus (status) {
      const map = {
        created: 'Creado',
        approved: 'Aprobado',
        paid: 'Pagado',
        packed: 'Empacado',
        sent: 'Enviado',
        declined: 'Declinado',
        expired: 'Expirado'
      }
      return map[status] || status
    }
  },

  computed: {
    styleStatus () {
      const c = this.colorsStatus[this.data.status]
      if (!c) return ''
      return `background: ${c.background}; color: ${c.color}`
    }
  }
}
</script>

<style lang="stylus">
.ow-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.ow-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis calc(100% - 3rem)
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.ow-actions-container
  display flex
  align-items center
  gap 1.5rem
  padding 0 1rem

.ow-actions
  display flex
  align-items center
  gap 1em

.ow-number
  display flex
  align-items center
  gap .5em

.ow-method
  display flex
  justify-content center

.ow-method img
  height 1.4em
  display block

.ow-print .material-symbols-outlined
  font-size 1.4em
  opacity .5
  cursor pointer

.ow-print .material-symbols-outlined:hover
  opacity 1

.list-ow
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .ow-data
    flex-basis calc(100% - 16rem - 5rem)
    column-gap 0
    row-gap 1em

  .ow-number
    width 10em
  .ow-status
    width 7em
  .ow-method
    width 5em
  .ow-total
    width 8em
  .ow-collected
    width 8em
  .ow-name
    width 7em
  .ow-location
    width 8em
  .ow-phone
    width 8em
  .ow-date
    width 10em
  .ow-transaction
    width 8em
  .ow-actions
    width 16em

  .ow-actions-container
    padding 0
</style>



// WEBPACK FOOTER //
// src/components/pages/orderWholesaler/OrderWholesaler.vue